import React from 'react'
import styles from './cheers.module.css'

export default function Cheers() {
  return (
    <svg className={styles.icon} viewBox="0 0 512 512">
      <path
        fill="#a8d3d8"
        d="M373.7 364.402l50.1 108.899L437.603 467l13.5-6.3L401 351.8l-13.5 6.302zm0 0"
      />
      <path
        fill="#8ebac5"
        d="M387.5 358.102l-13.8 6.3 50.1 108.899L437.603 467zm0 0"
      />
      <path
        fill="#00b03a"
        d="M257 269.3s12.3 40.2 13.2 43.2c12.6 52.2 71.402 83.102 123.3 59.102C444.5 348.199 461 284.3 428 239c0-.3-21.602-34.5-23.7-37.5l-67.5.898-15.296 12.903zm0 0"
      />
      <path
        fill="#00973a"
        d="M257 269.3s12.3 40.2 13.2 43.2c12.6 52.2 71.402 83.102 123.3 59.102l-72-156.301zm0 0"
      />
      <path
        fill="#a8d3d8"
        d="M363.2 484.7c1.5 2.402 11.1 24.3 12.6 27.3l68.098-31.5L512 449c-1.5-2.398-11.102-23.7-12.598-27-2.101.902-35.101 16.2-68.101 31.2-32.102 15-63.903 30-68.102 31.5zm0 0"
      />
      <path
        fill="#8ebac5"
        d="M363.2 484.7c1.5 2.402 11.1 24.3 12.6 27.3l68.098-31.5-12.597-27.3c-32.102 15-63.903 30-68.102 31.5zm0 0"
      />
      <path
        fill="#c6e2e7"
        d="M239 211.7l18 57.6 73.8-33.898 73.5-33.902-32.398-51.3-66.3 30.6zm0 0"
      />
      <path
        fill="#a8d3d8"
        d="M239 211.7l18 57.6 73.8-33.898-25.198-54.601zm0 0"
      />
      <path fill="#fed2a4" d="M241 0h30v92h-30zm0 0" />
      <path
        fill="#ffbd86"
        d="M351.46 35.324l21.212 21.211-63.645 63.645-21.21-21.211zm0 0"
      />
      <path
        fill="#fed2a4"
        d="M160.535 35.324l63.649 63.649-21.211 21.21-63.649-63.648zm0 0"
      />
      <path
        fill="#c6e2e7"
        d="M138.3 364.402L88.2 473.301 74.397 467l-13.5-6.3L111 351.8l13.5 6.302zm0 0"
      />
      <path
        fill="#a8d3d8"
        d="M124.5 358.102l13.8 6.3-50.1 108.899L74.397 467zm0 0"
      />
      <path
        fill="#9e1558"
        d="M255 269.3s-12.3 40.2-13.2 43.2c-12.6 52.2-71.402 83.102-123.3 59.102C67.5 348.199 51 284.3 84 239c0-.3 21.602-34.5 23.7-37.5l67.5.898 15.3 12.903zm0 0"
      />
      <path
        fill="#8d1558"
        d="M255 269.3s-12.3 40.2-13.2 43.2c-12.6 52.2-71.402 83.102-123.3 59.102l72-156.301zm0 0"
      />
      <path
        fill="#c6e2e7"
        d="M148.8 484.7c-1.5 2.402-11.1 24.3-12.6 27.3l-68.098-31.5L0 449c1.5-2.398 11.102-23.7 12.598-27 2.101.902 35.101 16.2 68.101 31.2 32.102 15 63.903 30 68.102 31.5zm0 0"
      />
      <path
        fill="#a8d3d8"
        d="M148.8 484.7c-1.5 2.402-11.1 24.3-12.6 27.3l-68.098-31.5 12.597-27.3c32.102 15 63.903 30 68.102 31.5zm0 0"
      />
      <path
        fill="#deecf1"
        d="M273 211.7l-18 57.6-73.8-33.898-73.5-33.902 32.398-51.3 66.3 30.6zm0 0"
      />
      <path
        fill="#c6e2e7"
        d="M273 211.7l-18 57.6-73.8-33.898 25.198-54.601zm0 0"
      />
      <path fill="#ffbd86" d="M256 0h15v92h-15zm0 0" />
    </svg>
  )
}
